<template>
  <el-cascader
    ref="cascader"
    v-model="c"
    :options="options"
    :props="props"
    size="mini"
    :disabled="disabled"
    change-on-select
    :clearable="clearable"
    :placeholder="placeholder"
    @blur="handleBlur"
    @change="handleChange"
  ></el-cascader>
</template>

<script>
import { mapState } from 'vuex'
// 省市区级联面板，由于是异步的，必须允许change-on-select，即选择任意一级，业务自主验证，因为这个版本的el没有lazy
export default {
  props: {
    value: Array, // vmodel值
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String
  },
  data() {
    return {
      props: {
        value: 'id',
        children: 'children',
        label: 'name'
      }
    }
  },

  computed: {
    ...mapState(['common']),
    c: {
      get() {
        return this.value
      },
      set(val) {
        const len = val.length
        switch (len) {
          case 1:
            this.$store.dispatch('getCityList', val[len - 1])
            break
          case 2:
            this.$store.dispatch('getDistrict', val[len - 1])
            break
        }
        this.$emit('input', val)
      }
    },
    options() {
      return this.common.areaList
    }
  },

  watch: {

  },

  methods: {
    async init() {
      // 省
      await this.$store.dispatch('getProvinceList', 156)
      this.value[1] && (await this.$store.dispatch('getCityList', this.value[0]))
      this.value[2] && (await this.$store.dispatch('getDistrict', this.value[1]))
    },

    handleBlur() {

    },

    handleChange(val) {
      const labels = (this.$refs.cascader && this.$refs.cascader.currentLabels) || []
      this.$emit('handleChange', val, labels)
    }
  },

  async mounted() {
    await this.init()
  }
}
</script>
